export default __webpack_public_path__ + "377a9199421dc46ed4b12ce4aa04feeb.png";